import { useSelector } from 'react-redux';
import { PieChart, Pie, Cell, Legend, Tooltip } from 'recharts';
import ScrollContainer from '../../components/UI/ScrollContainer';
// import Quotations from "../../components/Quotations";
import SummaryTable from "./summary/SummaryTable";

import classes from "./WalletSummary.module.css";
import { useEffect, useState } from 'react';

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
        <text x={x} y={y} fill="#000" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
            {`${(percent * 100).toFixed(2)}%`}
        </text>
    );
};

async function fetchDollarCurrent() {
    try {
        const response = await fetch(
            'https://investidorlibertario.terradata.com.br/api/quotations/dollar.php'
        );

        if (!response.ok) {
            throw new Error('Erro ao obter cotação do dólar');
        }

        const data = await response.json();
        const value = data.value;
        console.warn(value)
        // ajuste o campo conforme o retorno real da API
        const dollarCurrent = Number(value) ?? 0;

        localStorage.setItem('dollarCurrent', dollarCurrent);

        return dollarCurrent;
    } catch (error) {
        console.error(error);
        return null;
    }
}

function WalletSummary() {
    const total = useSelector(state => state.total);
    const totalFixas = useSelector(state => state.totalFixas);
    const totalAcoes = useSelector(state => state.totalAcoes);
    const totalFIIs = useSelector(state => state.totalFIIs);
    const totalStocks = useSelector(state => state.totalStocks);
    const totalETFs = useSelector(state => state.totalETFs);
    const totalREITs = useSelector(state => state.totalREITs);

    useEffect(() => {
        fetchDollarCurrent();
    }, []);

    const data = [
        { color: '#00ff00', name: 'Renda Fixa', value: totalFixas / total },
        { color: '#fedf00', name: 'Ações', value: totalAcoes / total },
        { color: '#00ffff', name: 'FIIs', value: totalFIIs / total },
        { color: '#bd4050', name: 'Stocks', value: totalStocks / total },
        { color: '#1e90ff', name: 'ETFs', value: totalETFs / total },
        { color: '#6495ed', name: 'REITs', value: totalREITs / total },
        { color: '#ab8620', name: 'BITCOIN', value: 0 },
        { color: '#9c7ad6', name: 'ETHEREUM', value: 0 },
        { color: '#ca9a73', name: 'BNB', value: 0 },
    ];

    function filterEmpty(data) {
        return data.filter(item => item.value !== 0);
    }

    // Componente customizado para o Tooltip
    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            const total = data.reduce((sum, item) => sum + item.value, 0);
            const percentage = ((payload[0].value / total) * 100).toFixed(2);
            return (
                <div
                    style={{
                        backgroundColor: '#fff',
                        border: '1px solid #ccc',
                        padding: '10px',
                        borderRadius: '5px',
                    }}
                >
                    {payload[0].name}: {percentage}%
                </div>
            );
        }
        return null;
    };

    return <>
        <div className='row'>
            <div className='col col-md-12'>
                <ScrollContainer heightMultiplier={0.676} overflowY='hidden'>
                    <div className="row">
                        <div className="col col-md-2 mt-1">
                            {!isNaN(data[0].value) && !isNaN(data[1].value) && !isNaN(data[2].value)
                                && !isNaN(data[3].value) && !isNaN(data[4].value) && !isNaN(data[5].value) ? (
                                <PieChart width={400} height={400}>
                                    <Pie
                                        data={filterEmpty(data)}
                                        cx="50%"
                                        cy="50%"
                                        labelLine={false}
                                        label={renderCustomizedLabel}
                                        outerRadius={180}
                                        fill="#8884d8"
                                        dataKey="value"
                                    >
                                        {data.map((entry, index) => (
                                            <Cell key={`cell-${index}`} fill={entry.color} />
                                        ))}
                                    </Pie>
                                    <Tooltip content={<CustomTooltip />} />
                                    <Legend
                                        layout="horizontal"
                                        verticalAlign="bottom"
                                        align="center"
                                        iconType="circle"
                                        formatter={(value, entry, index) => <small className={classes.smaller + " text-color-class"}><span className='text-dark'>{value}</span></small>}
                                    />
                                </PieChart>
                            ) : (
                                <div>Carregando gráfico...</div>
                            )}
                        </div>
                        <div className="col col-md-10">
                            <SummaryTable />
                        </div>
                    </div>
                </ScrollContainer>
            </div>
        </div>
    </>
}

export default WalletSummary;